import { allAvailableDatesField } from './fields/allAvailableDates.field';
import { setsAvailableDatesField } from './fields/setsAvailableDates.field';

export const eeDatesPolicies = {
    setsAvailableDates: setsAvailableDatesField,
    allAvailableDates: allAvailableDatesField,
    // eeAvailableDates: {
    //     read(_, { readField }) {
    //         return [];
    //     },
    // },

    // everydayAvailableDates: {
    //     read(_, { readField }) {
    //         return [
    //             '2025-07-31',
    //             '2025-08-01',
    //             '2025-08-02',
    //             '2025-08-03',
    //         ];
    //     },
    // },
};
